import React from "react";
import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { opacify } from "polished";

type Props = React.ComponentProps<typeof IconButton>;

export function SimpleIconButton(props: Props) {
  const classes = useStyles({});

  return (
    <IconButton
      classes={{
        root: classes.root
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    background: "transparent !important",
    padding: "0 !important",
    transition: theme.transitions.create(""),

    "&:hover": {
      background: "transparent !important",
      color: opacify(0.3, theme.palette.action.active)
    }
  }
}));
